import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {
    Alert,
    Button,
    Chip,
    CircularProgress,
    MenuItem,
    Select,
    Snackbar,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import './CaseDetails.css';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import DeclineInputField from "./DeclineInputField";
import ReuploadDeclinedDocument from "./ReuploadDeclinedDocument";
import LocationProps from "../../enums/LocationProps";
import {MdClose, MdOpenInNew, MdUpload} from "react-icons/md";
import isCaseParentIdRejectedEnum from "../../enums/isCaseParentIdRejectedEnum";
import UploadFileToCaseDetail from "./UploadFileTocaseDetail";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import nomenclatureEnum from "../../enums/nomenclatureEnum";
import {DescriptionOutlined} from "@mui/icons-material";
import ExcelPopup from "../../dashboard/apiTables/ExcelPopup";
import {FaPlus} from "react-icons/fa";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import EditObjectOwnerPopup from "./EditObjectOwnerPopup";
import CaseFilesStatus from "../../enums/CaseFilesStatus";

const CaseDetails = ({
                         permitTypeId,
                         caseMustBeActive,
                         role,
                         caseDetails,
                         onDetailChange,
                         caseFiles,
                         isButtonVisible,
                         onFileAdded,
                         onCaseStatusChange,
                         caseGeography,
                         geoIds,
                         caseParentId,
                         documentToChangeId = null,
                         isCaseParentIdRejected,
                         onCaseParentIdRejection,
                         caseData,
                         caseInfo,
                         isObjectInRegistery,
                         users,
                         isAddressRejected,
                         orderDepartment,
                         isCadastralCodeRejected,
                         isPopup = false,
                         hideDeclineButton = false,

                     }) => {
    const [dropdownData, setDropdownData] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [editedDetails, setEditedDetails] = useState([]);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertCadastral, setShowAlertCadastral] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [startUpload, setStartUpload] = useState(false);
    const [hasDeclinedDetails, setHasDeclinedDetails] = useState(false);
    const urlParams = new URLSearchParams(window.location.search);
    const caseId = urlParams.get('id');
    const [municipalities, setMunicipalities] = useState([]);
    const [regions, setRegions] = useState([]);
    const [councils, setCouncils] = useState([]);
    const [populatedAreas, setPopulatedAreas] = useState([]);
    const municipalitiesOptions = municipalities.map(municipality => ({
        value: municipality.id,
        label: municipality.typesName
    }));
    const councilsOptions = councils.map(council => ({value: council.id, label: council.typesName}));
    const populatedAreasOptions = populatedAreas.map(populatedArea => ({
        value: populatedArea.id,
        label: populatedArea.typesName
    }));
    const regionOptions = regions.map(region => ({value: region.id, label: region.itemName}));
    const [selectedRegionId] = useState(caseGeography.region.id);
    const [selectedMunicipalityId] = useState(caseGeography.city.id);
    const [selectedCouncilId] = useState(caseGeography.council.id);
    const [showUploadPopup, setShowUploadPopup] = useState({});
    const [editedCaseParentId, setEditedCaseParentId] = useState(caseParentId);
    const [editedAddress, setEditedAddress] = useState(caseInfo.address);
    const [editedCadastralCode, setEditedCadastralCode] = useState('');
    const [selectedRegionIds, setSelectedRegionIds] = useState([]);
    const [selectedMunicipalityIds, setSelectedMunicipalityIds] = useState([]);
    const [selectedCouncilIds, setSelectedCouncilIds] = useState([]);
    const [selectedPopulatedAreaIds, setSelectedPopulatedAreaIds] = useState([]);
    const [initialRegionIds, setInitialRegionIds] = useState([]);
    const [initialMunicipalityIds, setInitialMunicipalityIds] = useState([]);
    const [initialCouncilIds, setInitialCouncilIds] = useState([]);
    const [initialPopulatedAreaIds, setInitialPopulatedAreaIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [noteEditMode, setNoteEditMode] = useState(false);
    const [isChangeObjectOwnerPopupVisible, setIsChangeObjectOwnerPopupVisible] = useState(false);
    const [isExpChaneVisible, setIsExpChaneVisible] = useState(false);
    const [editedNote, setEditedNote] = useState(caseInfo.note || '');
    const [editedGeoDetails, setEditedGeoDetails] = useState([]);
    const [isCadastralCodeLoading, setIsCadastralCodeIsLoading] = useState(false);
    const [alert, setAlert] = useState({message: '', severity: 'info'});
    const [cadastralCode, setCadastralCode] = useState('');
    const [allFilesUploaded, setAllFilesUploaded] = useState(false);
    const declinationDocExist = (caseFiles.some(file => file.decline === CaseFileDeclined.DeclinationDocument));

    const handleGeoDetailChange = (field, newValue, oldValue) => {
        setEditedGeoDetails((prevState) => {
            const existingDetail = prevState.find((detail) => detail.field === field);
            const updatedDetails = prevState.filter((detail) => detail.field !== field);

            return [
                ...updatedDetails,
                {
                    field,
                    oldValue: existingDetail ? existingDetail.oldValue : oldValue,
                    newValue,
                },
            ];
        });
    };


    useEffect(() => {
        setInitialRegionIds(convertStringToArray(caseGeography.region.id));
        setInitialMunicipalityIds(convertStringToArray(caseGeography.city.id));
        setInitialCouncilIds(convertStringToArray(caseGeography.council.id));
        setInitialPopulatedAreaIds(convertStringToArray(caseGeography.populatedArea.id));

        setSelectedRegionIds(convertStringToArray(caseGeography.region.id));
        setSelectedMunicipalityIds(convertStringToArray(caseGeography.city.id));
        setSelectedCouncilIds(convertStringToArray(caseGeography.council.id));
        setSelectedPopulatedAreaIds(convertStringToArray(caseGeography.populatedArea.id));
    }, [caseGeography]);

    const formatSelectedIds = (selectedIds) => {
        return selectedIds.map(id => `-${id}-`).join(',');
    };

    const handleDeleteCadastralCode = (codeToDelete) => {
        const updatedCodes = editedCadastralCode
            .split('$')
            .filter(code => code !== codeToDelete)
            .join('$');
        setEditedCadastralCode(updatedCodes);
    };


    const convertStringToArray = (str) => {
        if (!str) {
            return [];
        }
        return str
            .split(',')
            .map(item => parseInt(item.replace(/-/g, ''), 10))
            .filter(item => !isNaN(item));
    };

    const handleCaseNumberClick = (caseId) => {
        window.open(`/dashboard/mycases/casemanager?id=${caseId}`, '_blank');
    };


    const toggleUploadPopup = (id) => {
        setShowUploadPopup(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const regionsResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/DictionaryTypesDetalisById?CategoryId=${geoIds.regionId}`);
                if (regionsResponse.data.success) {
                    setRegions(regionsResponse.data.data.resultlist);
                }
            } catch (error) {
            }
        };
        void fetchData();
    }, []);

    useEffect(() => {
        if (selectedRegionId) {
            const fetchMunicipalities = async () => {
                try {
                    const regionIdsArray = convertStringToArray(selectedRegionId);
                    const dictionaryRequests = regionIdsArray.map(councilId => ({
                        dictionaryTypeId: geoIds.municipalityId,
                        dictionaryId: councilId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data.success) {
                        setMunicipalities(response.data.data);
                    }
                } catch (error) {
                }
            };
            void fetchMunicipalities();
        }
    }, [selectedRegionId]);

    useEffect(() => {
        if (selectedMunicipalityId) {
            const fetchCouncils = async () => {
                try {
                    const councilIdsArray = convertStringToArray(selectedMunicipalityId);
                    const dictionaryRequests = councilIdsArray.map(councilId => ({
                        dictionaryTypeId: geoIds.councilId,
                        dictionaryId: councilId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data.success) {
                        setCouncils(response.data.data);
                    }
                } catch (error) {
                }
            };
            void fetchCouncils();
        }
    }, [selectedCouncilId]);

    useEffect(() => {
        if (selectedCouncilId) {
            const fetchPopulatedAreas = async () => {
                try {
                    const populatedAreaIdArray = convertStringToArray(selectedCouncilId);
                    const dictionaryRequests = populatedAreaIdArray.map(councilId => ({
                        dictionaryTypeId: geoIds.cityId,
                        dictionaryId: councilId
                    }));
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
                    if (response.data.success) {
                        setPopulatedAreas(response.data.data);
                    }
                } catch (error) {
                }
            };
            void fetchPopulatedAreas();
        }
    }, [selectedCouncilId]);


    const handleRegionChange = async (selectedRegionIds) => {
        try {

            const dictionaryRequests = selectedRegionIds.map(regionId => ({
                dictionaryTypeId: geoIds.municipalityId,
                dictionaryId: regionId
            }));

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});

            if (response.data.success) {
                setMunicipalities(response.data.data);

            }
        } catch (error) {
        }
    };

    const handleMunicipalityChange = async (selectedMunicipalityIds) => {
        try {
            const dictionaryRequests = selectedMunicipalityIds.map(regionId => ({
                dictionaryTypeId: geoIds.councilId,
                dictionaryId: regionId
            }));
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
            if (response.data.success) {
                setCouncils(response.data.data);
            }
        } catch (error) {
        }
    };

    const handleCouncilChange = async (selectedCouncilId) => {
        try {
            const dictionaryRequests = selectedCouncilId.map(regionId => ({
                dictionaryTypeId: geoIds.cityId,
                dictionaryId: regionId
            }));

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
            if (response.data.success) {
                setPopulatedAreas(response.data.data);
            }
        } catch (error) {
        }
    };

    const fetchCadastralCode = async (cadastralCode) => {
        if (!cadastralCode) {
            return;
        }
        setIsCadastralCodeIsLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCADCodeByCadastralCode?CadastralCode=${cadastralCode}`);
            if (response.data.success) {
                if (response.data.success) {
                    setEditedCadastralCode(prev => {
                        const codes = prev ? prev.split('$') : [];
                        if (!codes.includes(cadastralCode)) {
                            setCadastralCode('');
                            setAlert({message: 'ოპერაცია წარმატებით დასრულდა!', severity: 'success'});
                            return codes.concat(cadastralCode).join('$');
                        } else {
                            setAlert({message: 'საკადასტრო კოდი უკვე დამატებულია სიაში!', severity: 'warning'});
                            return prev;
                        }
                    });

                } else {
                    setAlert({message: 'საკადასტრო კოდი არ არსებობს!', severity: 'warning'});
                }
            } else if (!response.data.success) {
                const errorMessage = response.data.errors.message || 'საკადასტრო კოდი არასწორია';
                setAlert({message: errorMessage, severity: 'error'});
            } else {
                setAlert({message: 'დაფიქსირდა შეცდომა!', severity: 'error'});
            }
        } catch (error) {
            setAlert({message: 'დაფიქსირდა შეცდომა!', severity: 'error'});
        }
        setIsCadastralCodeIsLoading(false);
        setShowAlertCadastral(true);
    };


    const isParentRejected = (geoKey) => {
        switch (geoKey) {
            case 'city':
                return caseGeography.region.rejected === 1;
            case 'council':
                return caseGeography.city.rejected === 1;
            case 'populatedArea':
                return caseGeography.council.rejected === 1;
            default:
                return false;
        }
    };

    const isParentRejectedAfterUserSent = (geoKey) => {
        switch (geoKey) {
            case 'city':
                return caseGeography.region.rejected === 3;
            case 'council':
                return caseGeography.city.rejected === 3;
            case 'populatedArea':
                return caseGeography.council.rejected === 3;
            default:
                return false;
        }
    };

    const toggleGeographyRejectedStatus = async (geoKey) => {
        const updatedGeography = {...caseGeography};
        setIsLoading(true)

        updatedGeography[geoKey] = {
            ...updatedGeography[geoKey],
            rejected: updatedGeography[geoKey].rejected === 0 ? 1 : 0
        };

        switch (geoKey) {
            case 'region':
                updatedGeography.city.rejected = updatedGeography.region.rejected;
                updatedGeography.council.rejected = updatedGeography.region.rejected;
                updatedGeography.populatedArea.rejected = updatedGeography.region.rejected;
                break;
            case 'city':
                updatedGeography.council.rejected = updatedGeography.city.rejected;
                updatedGeography.populatedArea.rejected = updatedGeography.city.rejected;
                break;
            case 'council':
                updatedGeography.populatedArea.rejected = updatedGeography.council.rejected;
                break;
        }

        const payload = {
            caseId: caseId,
            councilRejected: updatedGeography.council.rejected,
            populatedAreaRejected: updatedGeography.populatedArea.rejected,
            regionRejected: updatedGeography.region.rejected,
            cityRejected: updatedGeography.city.rejected,
            council: updatedGeography.council.id,
            populatedArea: updatedGeography.populatedArea.id,
            region: updatedGeography.region.id,
            city: updatedGeography.city.id,
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseRejectedPropertiesByCaseId`, payload);
            onCaseStatusChange();
            setIsLoading(false)
        } catch (error) {
        }
    };

    const toggleGeographyRejectedStatusAfterUserSent = async (geoKey) => {
        setIsLoading(true)
        const updatedGeography = {...caseGeography};

        updatedGeography[geoKey] = {
            ...updatedGeography[geoKey],
            rejected: updatedGeography[geoKey].rejected === 0
        };

        switch (geoKey) {
            case 'region':
                updatedGeography.city.rejected = updatedGeography.region.rejected;
                updatedGeography.council.rejected = updatedGeography.region.rejected;
                updatedGeography.populatedArea.rejected = updatedGeography.region.rejected;
                break;
            case 'city':
                updatedGeography.council.rejected = updatedGeography.city.rejected;
                updatedGeography.populatedArea.rejected = updatedGeography.city.rejected;
                break;
            case 'council':
                updatedGeography.populatedArea.rejected = updatedGeography.council.rejected;
                break;
        }

        const payload = {
            caseId: caseId,
            councilRejected: 0,
            populatedAreaRejected: 0,
            regionRejected: 0,
            cityRejected: 0,
            council: updatedGeography.council.id,
            populatedArea: updatedGeography.populatedArea.id,
            region: updatedGeography.region.id,
            city: updatedGeography.city.id,
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseRejectedPropertiesByCaseId`, payload);
            onCaseStatusChange();
            setIsLoading(false)
        } catch (error) {
        }
    };


    const getCityNameById = (cityIds) => {
        if (cityIds === null || cityIds === '') {
            return "არ არის შევსებული"
        }

        const cityIdArray = cityIds.split(',').map(id => id.replace(/-/g, '')).filter(id => id);

        const cityNames = cityIdArray.map(cityId => {
            const city = municipalitiesOptions.find(c => c.value === parseInt(cityId, 10));
            return city ? city.label : '';
        });
        return cityNames.join(', ');
    };

    const getRegionById = (regionIds) => {

        if (regionIds === null || regionIds === '') {
            return "არ არის შევსებული"
        }

        const cityIdArray = regionIds.split(',').map(id => id.replace(/-/g, '')).filter(id => id);

        const regionNames = cityIdArray.map(cityId => {
            const region = regionOptions.find(c => c.value === parseInt(cityId, 10));
            return region ? region.label : '';
        });

        return regionNames.join(', ');
    };

    const getCouncliById = (cityId) => {
        if (cityId === null || cityId === '') {
            return "არ არის შევსებული"
        }


        const cityIdArray = cityId.split(',').map(id => id.replace(/-/g, '')).filter(id => id);

        const regionNames = cityIdArray.map(cityId => {
            const region = councilsOptions.find(c => c.value === parseInt(cityId, 10));
            return region ? region.label : '';
        });

        return regionNames.join(', ');
    };


    const getPopById = (cityId) => {
        if (cityId === null || cityId === '') {
            return "არ არის შევსებული"
        }

        const cityIdArray = cityId.split(',').map(id => id.replace(/-/g, '')).filter(id => id);
        const regionNames = cityIdArray.map(cityId => {
            const region = populatedAreasOptions.find(c => c.value === parseInt(cityId, 10));
            return region ? region.label : '';
        });
        return regionNames.join(', ');
    };


    useEffect(() => {
        const declinedCount = caseDetails.filter(detail => detail.declined === 2).length;
        const hasDeclinedGeoDetail = (caseGeography.city.rejected === 2 || caseGeography.region.rejected === 2 || caseGeography.council.rejected === 2 || caseGeography.populatedArea.rejected === 2)
        setHasDeclinedDetails((declinedCount > 0 || hasDeclinedGeoDetail || isAddressRejected === isCaseParentIdRejectedEnum.prepareDeclination || isCadastralCodeRejected === isCaseParentIdRejectedEnum.prepareDeclination));

    }, [caseDetails, caseGeography]);

    const handleCancelEdit = () => {
        setEditedDetails([]);
        setConfirmationModalOpen(false);
        setEditMode(false);
    };

    const toggleEditMode = () => {
        if (!editMode) {
            setEditedCaseParentId(caseParentId);
            setEditedAddress(caseInfo.address);
            setEditedCadastralCode(caseInfo.cadastralCode);
            setEditMode(true);
        } else {
            setConfirmationModalOpen(true);
        }
    };

    const isEditable = (detail) => {

        if (caseInfo.creteByExpert) {
            return true
        }

        if (role === "USER") {
            return detail.declined === 2;
        }

        if (caseData.editableEmployeeValues && detail.inputType !== 5) {
            return true;
        }

        if (caseData.editableUserValues && detail.inputType === 5) {
            return true;
        }
        return !caseData.editableUserValues && !caseData.editableEmployeeValues;
    };


    const sendUpdate = async (payload) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseRejectedPropertiesByCaseId`, payload);
            onCaseStatusChange()
        } catch (error) {
        }
    };
    const handleSaveConfirmed = async () => {

        setIsLoading(true)
        setConfirmationModalOpen(false);
        const formattedRegionIds = selectedRegionIds.length > 0 ? formatSelectedIds(selectedRegionIds) : formatSelectedIds(initialRegionIds);
        const formattedMunicipalityIds = selectedMunicipalityIds.length > 0 ? formatSelectedIds(selectedMunicipalityIds) : formatSelectedIds(initialMunicipalityIds);
        const formattedCouncilIds = selectedCouncilIds.length > 0 ? formatSelectedIds(selectedCouncilIds) : formatSelectedIds(initialCouncilIds);
        const formattedPopulatedAreaIds = selectedPopulatedAreaIds.length > 0 ? formatSelectedIds(selectedPopulatedAreaIds) : formatSelectedIds(initialPopulatedAreaIds);

        const payload = {
            caseId: caseId,
            region: formattedRegionIds,
            city: formattedMunicipalityIds,
            council: formattedCouncilIds,
            populatedArea: formattedPopulatedAreaIds,
            regionRejected: 0,
            cityRejected: 0,
            councilRejected: 0,
            populatedAreaRejected: 0
        };
        const payloadForUser = {
            caseId: caseId,
            region: formattedRegionIds,
            city: formattedMunicipalityIds,
            council: formattedCouncilIds,
            populatedArea: formattedPopulatedAreaIds,
            regionRejected: caseGeography.region.rejected === 2 ? LocationProps.notDeclined : caseGeography.region.rejected,
            cityRejected: caseGeography.city.rejected === 2 ? LocationProps.notDeclined : caseGeography.city.rejected,
            councilRejected: caseGeography.council.rejected === 2 ? LocationProps.notDeclined : caseGeography.council.rejected,
            populatedAreaRejected: caseGeography.populatedArea.rejected === 2 ? LocationProps.notDeclined : caseGeography.populatedArea.rejected,
        };


        const parentIdPayload = {
            caseId: caseId,
            caseParentId: editedCaseParentId,
            isRejectedCaseParentId: isCaseParentIdRejectedEnum.notDeclined,
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateParentCaseIdInfo`, parentIdPayload);
        } catch (error) {
        }


        const addressPayload = {
            id: caseId,
            address: editedAddress,
            addressDeclinedStatus: isCaseParentIdRejectedEnum.notDeclined,
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/EditCasePropertyAddressAndPropertyStatus`, addressPayload);
        } catch (error) {
        }

        const cadastralCodePayload = {
            id: caseId,
            cadastralCode: editedCadastralCode,
            addressDeclinedStatus: isCaseParentIdRejectedEnum.notDeclined,
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseCadastralInfo`, cadastralCodePayload);
        } catch (error) {
        }

        if (role === "USER") {
            await saveAllDetailsUser()
            await sendUpdate(payloadForUser);
            onCaseStatusChange()
        } else {
            await saveAllDetails();
            await sendNotification();
            await sendUpdate(payload);
            if (documentToChangeId) {
                await editChangeFile();
                onFileAdded();
            }
        }
        onCaseParentIdRejection()
        setEditMode(false);
        setIsLoading(false)
    };
    const sendNotification = async () => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const keys = editedDetails.map(detail => detail.key);
        const oldValues = editedDetails.map(detail => detail.previousValue);
        const newValues = editedDetails.map(detail => detail.currentValue);

        const geoKeys = editedGeoDetails.map(detail => detail.field);
        const geoOldValues = editedGeoDetails.map(detail => detail.oldValue.join(', '));
        const geoNewValues = editedGeoDetails.map(detail => detail.newValue.join(', '));

        const combinedKeys = keys.concat(geoKeys);
        const combinedOldValues = oldValues.concat(geoOldValues);
        const combinedNewValues = newValues.concat(geoNewValues);

        const caseNotification = {
            nextStepUserId: role === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.editedField.id,
            caseStatus: 8,
            viewed: true,
            key: combinedKeys,
            oldValue: combinedOldValues,
            newValue: combinedNewValues
        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };


    const saveAllDetails = async () => {
        setIsLoading(true)
        for (const [_, value] of Object.entries(editedDetails)) {
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseDetails`, {
                    value: value.currentValue,
                    id: value.id
                });
                setAlertType('success');
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setShowAlert(true);
            } catch (error) {
                setAlertType('error');
                setAlertMessage('Update failed: ' + error.message);
                setShowAlert(true);
            }
        }
        onDetailChange()
        setIsLoading(false)
    };

    const saveAllDetailsUser = async () => {
        setIsLoading(true)
        for (const [_, value] of Object.entries(editedDetails)) {
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseDetails`, {
                    value: value.currentValue,
                    id: value.id,
                    declined: DeclineInputField.No
                });
                setAlertType('success');
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setShowAlert(true);
            } catch (error) {
                setAlertType('error');
                setAlertMessage('Update failed: ' + error.message);
                setShowAlert(true);
            }
        }
        onDetailChange()
        setIsLoading(false)
    };

    const handleDetailChange = (id, currentValue, key, previousValue) => {
        setEditedDetails((prevState) => {
            const updatedDetails = prevState.filter((detail) => detail.id !== id);
            return [
                ...updatedDetails,
                {
                    id,
                    key,
                    currentValue,
                    previousValue: previousValue,
                },
            ];
        });
    };


    const fetchDropdownData = async (details) => {
        try {
            const dropdownResponses = await Promise.all(
                details
                    .filter(detail => detail.inputType === 1 || (detail.inputType === 5 && detail.dictionaryTypeId !== null))
                    .map(detail => axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDictionary?DictionaryTypeId=${detail.dictionaryTypeId}`))
            );

            const newDropdownData = {};
            dropdownResponses.forEach((response, index) => {
                const filteredDetails = details.filter(detail => detail.inputType === 1 || detail.inputType === 5);
                if (response.data.success) {
                    const dictionaryTypeId = filteredDetails[index].dictionaryTypeId;
                    newDropdownData[dictionaryTypeId] = response.data.data;
                }
            });
            setDropdownData(newDropdownData);
        } catch (err) {
        }
    };
    useEffect(() => {
        if (caseDetails.length > 0) {
            void fetchDropdownData(caseDetails);
        }
    }, [caseDetails]);

    const handleNoteSave = async () => {
        setIsLoading(true)
        const caseId = new URLSearchParams(window.location.search).get('id');
        const payload = {
            caseId: parseInt(caseId, 10),
            note: editedNote,
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseNote`, payload);
            setNoteEditMode(false);
            setAlertType('success');
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setShowAlert(true);
            await sendNotificationForNote(editedNote)
            onCaseStatusChange();
            setIsLoading(false)
        } catch (error) {
            setAlertType('error');
            setAlertMessage('დაფიქსირდა შეცოდმა');
            setShowAlert(true);
            setIsLoading(false)
        }
    };


    const sendNotificationForNote = async (newValue) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: role === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.editedField.id,
            caseStatus: 8,
            viewed: true,
            key: ["შენიშვნა"],
            oldValue: [caseInfo.note],
            newValue: [newValue]

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const handleDeclineDetail = async (id, value, action) => {
        setIsLoading(true)
        try {
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/UpdateCaseDetails`,
                {
                    id,
                    value,
                    declined: action === "decline" ? DeclineInputField.DeclinedInProgress : DeclineInputField.No
                }
            );
            onDetailChange();
            setIsLoading(false)
        } catch (error) {
        }
    };

    const handleDeclineParentId = async (value, action) => {
        try {
            setIsLoading(true)
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/UpdateParentCaseIdInfo`,
                {
                    caseId: caseId,
                    caseParentId: value,
                    isRejectedCaseParentId: action === "decline" ? isCaseParentIdRejectedEnum.prepareDeclination : isCaseParentIdRejectedEnum.notDeclined
                }
            );
            onCaseParentIdRejection();
            setIsLoading(false)
        } catch (error) {
        }
    };

    const handleDeclineAddress = async (value, action) => {
        try {
            setIsLoading(true)
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/EditCasePropertyAddressAndPropertyStatus`,
                {
                    id: caseId,
                    address: value,
                    addressDeclinedStatus: action === "decline" ? isCaseParentIdRejectedEnum.prepareDeclination : isCaseParentIdRejectedEnum.notDeclined
                }
            );
            onCaseParentIdRejection();
            setIsLoading(false)
        } catch (error) {
        }
    };

    const editChangeFile = async () => {
        try {
            if (documentToChangeId) {
                const updatedFileData = {
                    ...documentToChangeId,
                    changeDocumentStatus: 2,
                };

                try {
                    await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, updatedFileData);

                } catch (error) {
                    setAlertMessage('Error updating file shared status');
                    setAlertType('error');
                    setShowAlert(true);

                }
            }

        } catch (error) {
        }
    };

    const handleDeclineCadastralCode = async (value, action) => {
        try {
            setIsLoading(true)
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/UpdateCaseCadastralInfo`,
                {
                    id: caseId,
                    cadastralCode: value,
                    cadastralCodeDenclinedStatus: action === "decline" ? isCaseParentIdRejectedEnum.prepareDeclination : isCaseParentIdRejectedEnum.notDeclined
                }
            );
            onCaseParentIdRejection();
            setIsLoading(false)
        } catch (error) {
        }
    };

    const checkIfObjectIsInRegistery = (objects, object) => {
        return objects.filter(item => item.id === object).length !== 0
    };

    return (
        <div>
            <ExcelPopup isVisible={isCadastralCodeLoading}
                        loaderText={"მიმდინარეობს საკადასტრო კოდის ვერიფიკაცია"}
                        loaderType={"CadastralCode"}/>
            <EditObjectOwnerPopup open={isChangeObjectOwnerPopupVisible} onClose={() => setIsChangeObjectOwnerPopupVisible(false)} caseDetails={caseDetails} onSave={onDetailChange} isExp={false}/>

                <EditObjectOwnerPopup open={isExpChaneVisible} onClose={() => setIsExpChaneVisible(false)} caseDetails={caseDetails} onSave={onDetailChange} isExp={true}/>


            <Snackbar
                open={showAlertCadastral}
                autoHideDuration={6000}
                onClose={() => {
                    setShowAlertCadastral(false);
                    setAlert({message: '', severity: 'info'})
                }}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                <Alert onClose={() => {
                    setShowAlertCadastral(false);
                    setAlert({message: '', severity: 'info'})
                }} severity={alert.severity} sx={{width: '100%'}}>
                    {alert.message}
                </Alert>
            </Snackbar>

            {isLoading ? (
                <div className={"initial-loader-container"}>
                    <DescriptionOutlined
                        sx={{
                            fontSize: 80,
                            color: 'rgba(255, 255, 255, 0.9)',
                            mb: 2,
                            animation: 'pulseIcon 1.5s ease-in-out infinite',
                        }}
                    />
                    <Typography
                        sx={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            color: 'rgba(255, 255, 255, 0.9)',
                            mb: 3,
                        }}
                    >
                        მონაცემები იტვირთება...
                    </Typography>
                    <CircularProgress sx={{color: 'rgba(255, 255, 255, 0.8)'}}/>
                </div>
            ) : (
                <div>
                    <div style={{
                        display: 'flex',
                        justifyContent: "space-between",
                        paddingLeft: 50,
                        paddingRight: 50
                    }}>
                        <h1 className="page-manager-title">დამატებითი ინფორმაცია</h1>
                        {((caseData) || isButtonVisible || (caseInfo.creteByExpert && role && role !== "USER")) && (
                            <div style={{display: 'flex', gap: 10, height: 35}}>

                                {editMode ? (
                                    <div>
                                        <Button
                                            style={{width: 200, marginRight: 10}}
                                            variant="contained"
                                            color="primary"
                                            onClick={toggleEditMode}
                                        >
                                            შენახვა
                                        </Button>
                                        <Button style={{width: 200}} variant="contained" color="secondary"
                                                onClick={handleCancelEdit}>
                                            გაუქმება
                                        </Button>
                                    </div>
                                ) : (
                                    <>
                                        {role !== "USER" && role !== null && !declinationDocExist && (
                                            <Button style={{width: 200}} variant="contained"
                                                    onClick={toggleEditMode}>
                                                რედაქტირება
                                            </Button>
                                        )}

                                        {role === "USER" && hasDeclinedDetails && isPopup && (
                                            <Button style={{width: 200}} variant="contained"
                                                    onClick={toggleEditMode}>
                                                რედაქტირება
                                            </Button>
                                        )}
                                        {role !== "USER" && !editMode && !declinationDocExist &&(
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => setIsChangeObjectOwnerPopupVisible(true)}
                                                style={{marginLeft: '10px'}}
                                            >
                                                დამკვეთის შეცვლა
                                            </Button>
                                        )}

                                        {role !== "USER" && !editMode && orderDepartment === nomenclatureEnum.registery && !declinationDocExist && (
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => setIsExpChaneVisible(true)}
                                                style={{marginLeft: '10px'}}
                                            >
                                                ექსპლუატაციაში გამწვევი პირის შეცვლა
                                            </Button>
                                        )}
                                        {isButtonVisible && isPopup && (
                                            <Tooltip
                                                title={hasDeclinedDetails ? "ჯერ დაარედაქტირეთ დახარვეზებული ველები" : !allFilesUploaded ? "ატვირთეთ ყველა დოკუმენტი!" : ""}>
                                                <div
                                                    style={{cursor: hasDeclinedDetails || !allFilesUploaded ? "not-allowed" : "pointer"}}>
                                                    <Button
                                                        style={{width: 200}}
                                                        variant="contained"
                                                        disabled={hasDeclinedDetails || !allFilesUploaded}
                                                        onClick={() => setStartUpload(true)}
                                                    >
                                                        გაგზავნა
                                                    </Button>

                                                </div>
                                            </Tooltip>
                                        )}
                                    </>
                                )}
                            </div>
                        )}

                    </div>
                    <div>

                        {isPopup && !hasDeclinedDetails ? (<></>) : (

                            <div className="case-details-container">

                                {caseParentId !== null && (
                                    <div
                                        className="case-detail"
                                        style={{
                                            border: `1px solid ${(isCaseParentIdRejected === isCaseParentIdRejectedEnum.prepareDeclination || isCaseParentIdRejected === isCaseParentIdRejectedEnum.Declined) ? '#ea1717' :
                                                (isCaseParentIdRejected === isCaseParentIdRejectedEnum.UserSentBack && role !== "USER") ? "#ff9470"

                                                    : '#e0e0e0'}`
                                        }}>
                                        <span className="case-key">{"წინა სტადიის განაცხადის ნომერი"}:</span>
                                        {editMode && role === "USER" ? (
                                                <TextField
                                                    value={editedCaseParentId}
                                                    onChange={(e) => setEditedCaseParentId(e.target.value)}
                                                    type="text"
                                                    style={{margin: '0 8px'}}
                                                />
                                            ) :
                                            (
                                                <span onClick={() => handleCaseNumberClick(caseParentId)}
                                                      className="case-value-url">{caseParentId}</span>
                                            )}

                                        {role !== "USER" && !editMode && caseMustBeActive && isCaseParentIdRejected === isCaseParentIdRejectedEnum.prepareDeclination && (
                                            <Button
                                                variant="contained"
                                                color="success"
                                                disabled={declinationDocExist}
                                                onClick={() => handleDeclineParentId(caseParentId, "undecline")}
                                            >
                                                ხარვეზის მოხსნა
                                            </Button>
                                        )}
                                        {role !== "USER" && !declinationDocExist && !hideDeclineButton && !editMode && caseMustBeActive && (isCaseParentIdRejected === isCaseParentIdRejectedEnum.notDeclined || isCaseParentIdRejected === null) && (
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={() => handleDeclineParentId(caseParentId, "decline")}
                                            >
                                                დახარვეზება
                                            </Button>
                                        )}
                                        {role !== "USER" && !editMode && caseMustBeActive && (isCaseParentIdRejected === isCaseParentIdRejectedEnum.UserSentBack) && (
                                            <Button
                                                variant="contained"
                                                color="success"
                                                disabled={declinationDocExist}
                                                onClick={() => handleDeclineParentId(caseParentId, "undecline")}
                                            >
                                                ხარვეზის მოხსნა
                                            </Button>

                                        )}
                                    </div>
                                )}

                                {Object.entries(caseGeography)
                                    .slice(0, orderDepartment === nomenclatureEnum.building ? 4 : 2)
                                    .map(([key, geoDetail]) => {
                                        const titles = {
                                            region: "რეგიონი",
                                            city: "მუნიციპალიტეტი",
                                            council: "საკრებულო",
                                            populatedArea: "დასახლებული პუნქტი"
                                        };

                                        if (isPopup && geoDetail.rejected !== LocationProps.declinedAndSentToUser) return null;

                                        return (
                                            <div key={key} className="case-detail"
                                                 style={{
                                                     border: `1px solid ${(geoDetail.rejected === LocationProps.declined || geoDetail.rejected === LocationProps.declinedAndSentToUser) ? '#ea1717' :
                                                         geoDetail.rejected === LocationProps.UserSentBack && role !== "USER" ? "#ff9470" : '#e0e0e0'}`
                                                 }}>

                                                {(geoDetail.rejected === LocationProps.declinedAndSentToUser && role === "USER" && titles[key] === "რეგიონი" && editMode) || (editMode && role !== "USER" && titles[key] === "რეგიონი" && ((role !== "USER"))) ? (
                                                        <>
                                                            <span className="case-key">რეგიონი:</span>
                                                            <Select
                                                                multiple
                                                                value={selectedRegionIds}
                                                                onChange={(event) => {
                                                                    const value = event.target.value;
                                                                    setSelectedRegionIds(value);
                                                                    handleGeoDetailChange('რეგიონი', value, selectedRegionIds);
                                                                    void handleRegionChange(value);
                                                                }}
                                                                displayEmpty
                                                                fullWidth
                                                            >
                                                                {regionOptions.map((option) => (
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </>
                                                    )
                                                    : (geoDetail.rejected === LocationProps.declinedAndSentToUser && role === "USER" && titles[key] === "მუნიციპალიტეტი" && editMode) || (editMode && role !== "USER" && titles[key] === "მუნიციპალიტეტი" && ((role !== "USER"))) ?
                                                        (
                                                            <>
                                                                <span className="case-key">მუნიციპალიტეტი:</span>
                                                                <Select
                                                                    multiple
                                                                    value={selectedMunicipalityIds}
                                                                    onChange={(event) => {
                                                                        const value = event.target.value;
                                                                        setSelectedMunicipalityIds(value);
                                                                        handleGeoDetailChange('მუნიციპალიტეტი', value, selectedMunicipalityIds);
                                                                        void handleMunicipalityChange(value);

                                                                    }}
                                                                    disabled={(caseGeography.region.rejected === 1 && selectedRegionId === "")}
                                                                    fullWidth>
                                                                    {municipalities.map((municipality) => (
                                                                        <MenuItem key={municipality.id}
                                                                                  value={municipality.id}>
                                                                            {municipality.typesName}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </>
                                                        ) :

                                                        (geoDetail.rejected === LocationProps.declinedAndSentToUser && role === "USER" && titles[key] === "საკრებულო" && editMode) || (editMode && role !== "USER" && titles[key] === "საკრებულო" && ((role !== "USER"))) ?
                                                            (
                                                                <>
                                                                    <span className="case-key">საკრებულო:</span>
                                                                    <Select
                                                                        multiple
                                                                        value={selectedCouncilIds}
                                                                        onChange={(event) => {
                                                                            const value = event.target.value;
                                                                            handleGeoDetailChange('საკრებულო', value, selectedCouncilIds);
                                                                            setSelectedCouncilIds(value);
                                                                            void handleCouncilChange(value);
                                                                        }}
                                                                        displayEmpty
                                                                        fullWidth
                                                                        disabled={(caseGeography.city.rejected === 1 && selectedMunicipalityId === "")}
                                                                    >
                                                                        {councils.map((council) => (
                                                                            <MenuItem key={council.id}
                                                                                      value={council.id}>
                                                                                {council.typesName}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </>
                                                            ) :
                                                            (geoDetail.rejected === LocationProps.declinedAndSentToUser && role === "USER" && titles[key] === "დასახლებული პუნქტი" && editMode) || (editMode && role !== "USER" && titles[key] === "დასახლებული პუნქტი" && ((role !== "USER"))) ?
                                                                (
                                                                    <>
                                                                        <span
                                                                            className="case-key">დასახლებული
                                                                            პუნქტი:</span>
                                                                        <Select
                                                                            multiple
                                                                            value={selectedPopulatedAreaIds}
                                                                            onChange={(event) => {
                                                                                const value = event.target.value;
                                                                                handleGeoDetailChange('დასახლებული პუნქტი', value, selectedPopulatedAreaIds);
                                                                                setSelectedPopulatedAreaIds(event.target.value);
                                                                            }}
                                                                            displayEmpty
                                                                            fullWidth
                                                                            disabled={(caseGeography.council.rejected === 1 && selectedCouncilId === "")}
                                                                        >
                                                                            {populatedAreas.map((populatedArea) => (
                                                                                <MenuItem key={populatedArea.id}
                                                                                          value={populatedArea.id}>
                                                                                    {populatedArea.typesName}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </>
                                                                ) :
                                                                (<>
                                                                        <span className="case-key">{titles[key]}:</span>
                                                                        {titles[key] === "რეგიონი" && (
                                                                            <span
                                                                                className="case-value">{getRegionById(geoDetail.id)}</span>
                                                                        )}
                                                                        {titles[key] === "მუნიციპალიტეტი" && (
                                                                            <span
                                                                                className="case-value">{getCityNameById(geoDetail.id)}</span>
                                                                        )}
                                                                        {titles[key] === "საკრებულო" && (
                                                                            <span
                                                                                className="case-value">{getCouncliById(geoDetail.id)}</span>
                                                                        )}
                                                                        {titles[key] === "დასახლებული პუნქტი" && (
                                                                            <span
                                                                                className="case-value">{getPopById(geoDetail.id)}</span>
                                                                        )}
                                                                    </>
                                                                )}
                                                {caseMustBeActive && !declinationDocExist  && !hideDeclineButton && !editMode && (geoDetail.rejected === LocationProps.declined || geoDetail.rejected === LocationProps.notDeclined) && (
                                                    <Button
                                                        variant="contained"
                                                        color={geoDetail.rejected === LocationProps.declined ? "success" : "error"}
                                                        onClick={() => toggleGeographyRejectedStatus(key)}
                                                        disabled={(isParentRejected(key)) || (declinationDocExist && geoDetail.rejected === LocationProps.declined)}
                                                    >
                                                        {geoDetail.rejected === LocationProps.declined ? "ხარვეზის მოხსნა" : geoDetail.rejected === LocationProps.notDeclined ? "დახარვეზება" : ""}
                                                    </Button>
                                                )}
                                                {caseMustBeActive && !editMode && geoDetail.rejected === LocationProps.UserSentBack && (
                                                    <Button
                                                        variant="contained"
                                                        color="success"
                                                        onClick={() => toggleGeographyRejectedStatusAfterUserSent(key)}
                                                        disabled={isParentRejectedAfterUserSent(key) || declinationDocExist}
                                                    >
                                                        ხარვეზის მოხსნა
                                                    </Button>
                                                )}

                                            </div>
                                        );
                                    })}

                                {caseDetails.map((detail) => {
                                    if (role === "USER" && detail.inputType === 5) {
                                        return null;
                                    }
                                    if (isPopup && detail.declined !== DeclineInputField.Declined) {
                                        return null;
                                    }
                                    const isDetailLong = detail.value.length > 30;
                                    return (
                                        <div
                                            key={detail.id}
                                            className="case-detail"
                                            style={{
                                                border: `1px solid ${(detail.declined === DeclineInputField.DeclinedInProgress || detail.declined === 2) ? '#ea1717' :
                                                    detail.declined === DeclineInputField.DeclinedInProgress && role !== "USER" ? "ff9470" :
                                                        '#e0e0e0'}`
                                            }}
                                        >
                                            <span className="case-key">{detail.key}:</span>

                                            {editMode && isEditable(detail) ? (
                                                detail.dictionaryTypeId ? (
                                                    <Select
                                                        value={editedDetails.find((d) => d.id === detail.id)?.currentValue || detail.value}
                                                        onChange={(e) =>
                                                            handleDetailChange(detail.id, e.target.value, detail.key, detail.value)
                                                        }
                                                        style={{maxWidth: 200}}
                                                    >
                                                        {dropdownData[detail.dictionaryTypeId]?.map((option) => (
                                                            <MenuItem key={option.id} value={option.typesName}>
                                                                {option.typesName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                ) : (
                                                    <TextField
                                                        className="case-value"
                                                        defaultValue={detail.value}
                                                        onChange={(e) =>
                                                            handleDetailChange(detail.id, e.target.value, detail.key, detail.value)
                                                        }
                                                        margin="normal"
                                                    />
                                                )
                                            ) : (
                                                <div className="case-value" title={isDetailLong ? detail.value : ""}>
                                                    {detail.value}

                                                </div>
                                            )}


                                            <div>
                                                {(detail.hasFile || detail.hasDeadline) && (
                                                    <Button
                                                        style={{width: 50, height: 50, marginRight: 10}}
                                                        variant="contained"
                                                        onClick={() => toggleUploadPopup(detail.id)}
                                                    >
                                                        <MdUpload style={{fontSize: 24}}/>
                                                    </Button>
                                                )}
                                                {showUploadPopup[detail.id] && (
                                                    <UploadFileToCaseDetail
                                                        onClose={() => toggleUploadPopup(detail.id)}
                                                        caseDetail={detail}
                                                        onDetailChange={onDetailChange}
                                                    />
                                                )}
                                                {detail.hasFile && detail.fileUrl && (
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => window.open(detail.fileUrl, '_blank')}
                                                        style={{width: 50, height: 50}}
                                                    >
                                                        <MdOpenInNew style={{fontSize: 24}}/>
                                                    </Button>
                                                )}
                                            </div>

                                            {role !== "USER" && !editMode && caseMustBeActive && detail.inputType !== 5 && detail.declined === DeclineInputField.DeclinedInProgress && (
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    disabled={declinationDocExist}
                                                    onClick={() => handleDeclineDetail(detail.id, detail.value, "undecline")}
                                                >
                                                    ხარვეზის მოხსნა
                                                </Button>
                                            )}
                                            {role !== "USER" && !declinationDocExist  && !hideDeclineButton && !editMode && caseMustBeActive && detail.inputType !== 5 && (detail.declined === DeclineInputField.No || detail.declined === null) && (
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={() => handleDeclineDetail(detail.id, detail.value, "decline")}
                                                >
                                                    დახარვეზება
                                                </Button>
                                            )}
                                            {role !== "USER" && !editMode && caseMustBeActive && detail.inputType !== 5 && detail.declined === DeclineInputField.UserSentBack && (
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    disabled={declinationDocExist}
                                                    onClick={() => handleDeclineDetail(detail.id, detail.value, "undecline")}
                                                >
                                                    ხარვეზის მოხსნა
                                                </Button>
                                            )}

                                        </div>

                                    );
                                })}


                                <>
                                    {isCadastralCodeRejected !== isCaseParentIdRejectedEnum.prepareDeclination && isPopup ? (
                                        <></>
                                    ) : (
                                        <div
                                            style={{
                                                border: `1px solid ${(isCadastralCodeRejected === isCaseParentIdRejectedEnum.prepareDeclination || isCadastralCodeRejected === isCaseParentIdRejectedEnum.Declined) ? '#ea1717' :
                                                    (isCadastralCodeRejected === isCaseParentIdRejectedEnum.UserSentBack && role !== "USER") ? "#ff9470"
                                                        : '#e0e0e0'}`
                                            }}
                                            className="case-detail"
                                        >
                                            <span className="case-key">საკადასტრო კოდი:</span>

                                            {(editMode && role !== "USER") || (editMode && role === "USER" && isPopup && isCadastralCodeRejected === isCaseParentIdRejectedEnum.prepareDeclination) ? (
                                                    <div>
                                                        <div style={{display: "flex", gap: 5}}>
                                                            <TextField
                                                                value={cadastralCode}
                                                                onChange={(e) => setCadastralCode(e.target.value)}
                                                                type="text"
                                                                style={{margin: '0 8px'}}
                                                                fullWidth
                                                            />
                                                            <FaPlus
                                                                className={"input-search-button-cadastral" + (cadastralCode === "" ? " disabled" : "")}
                                                                onClick={() => fetchCadastralCode(cadastralCode)}
                                                                style={{
                                                                    cursor: cadastralCode === "" ? "not-allowed" : "pointer",
                                                                    color: cadastralCode === "" ? "#ccc" : "#0e5bd0"
                                                                }}
                                                            />

                                                        </div>
                                                        {editedCadastralCode && (
                                                            <>
                                                                <div className="casecreate-chips-container">
                                                                    {editedCadastralCode.split('$').map((code, index) => (
                                                                        <Chip
                                                                            key={index}
                                                                            label={code}
                                                                            onDelete={() => handleDeleteCadastralCode(code)}
                                                                            deleteIcon={<MdClose/>}
                                                                            className="casecreate-chips-chip"
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </>
                                                        )}

                                                    </div>
                                                ) :
                                                (
                                                    <span className="case-value">
                                                        {caseInfo.cadastralCode ? caseInfo.cadastralCode.replace(/\$/g, ', ') : ""}
                                                    </span>
                                                )}
                                            {role !== "USER" && !editMode && caseMustBeActive && isCadastralCodeRejected === isCaseParentIdRejectedEnum.prepareDeclination && (
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    disabled={declinationDocExist}
                                                    onClick={() => handleDeclineCadastralCode(caseInfo.cadastralCode, "undecline")}
                                                >
                                                    ხარვეზის მოხსნა
                                                </Button>
                                            )}
                                            {role !== "USER" && !declinationDocExist  && !hideDeclineButton && !editMode && caseMustBeActive && (isCadastralCodeRejected === isCaseParentIdRejectedEnum.notDeclined || isCadastralCodeRejected === null) && (
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={() => handleDeclineCadastralCode(caseInfo.cadastralCode, "decline")}
                                                >
                                                    დახარვეზება
                                                </Button>
                                            )}
                                            {role !== "USER" && !editMode && caseMustBeActive && (isCadastralCodeRejected === isCaseParentIdRejectedEnum.UserSentBack) && (
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    disabled={declinationDocExist}
                                                    onClick={() => handleDeclineCadastralCode(caseInfo.cadastralCode, "undecline")}
                                                >
                                                    ხარვეზის მოხსნა
                                                </Button>

                                            )}

                                        </div>
                                    )}


                                </>

                                {isAddressRejected !== isCaseParentIdRejectedEnum.prepareDeclination && isPopup ? (
                                    <></>
                                ) : (
                                    <div
                                        className="case-detail"
                                        style={{
                                            border: `1px solid ${(isAddressRejected === isCaseParentIdRejectedEnum.prepareDeclination || isAddressRejected === isCaseParentIdRejectedEnum.Declined) ? '#ea1717' :
                                                (isAddressRejected === isCaseParentIdRejectedEnum.UserSentBack && role !== "USER") ? "#ff9470"
                                                    : '#e0e0e0'}`
                                        }}>
                                        <span className="case-key">{"ობიექტის მისამართი"}:</span>

                                        {editMode && role !== "USER" || (editMode && role === "USER" && isPopup && isAddressRejected === isCaseParentIdRejectedEnum.prepareDeclination) ? (
                                                <TextField
                                                    value={editedAddress}
                                                    onChange={(e) => setEditedAddress(e.target.value)}
                                                    type="text"
                                                    style={{margin: '0 8px'}}
                                                />
                                            ) :
                                            (
                                                <span
                                                    className="case-value">{caseInfo.address}
                                                </span>
                                            )}

                                        {role !== "USER" && !editMode && caseMustBeActive && isAddressRejected === isCaseParentIdRejectedEnum.prepareDeclination && (
                                            <Button
                                                variant="contained"
                                                color="success"
                                                disabled={declinationDocExist}
                                                onClick={() => handleDeclineAddress(caseInfo.address, "undecline")}
                                            >
                                                ხარვეზის მოხსნა
                                            </Button>
                                        )}
                                        {role !== "USER" && !declinationDocExist  && !hideDeclineButton && !editMode && caseMustBeActive && (isAddressRejected === isCaseParentIdRejectedEnum.notDeclined || isAddressRejected === 0) && (
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={() => handleDeclineAddress(caseInfo.address, "decline")}
                                            >
                                                დახარვეზება
                                            </Button>
                                        )}
                                        {role !== "USER" && !editMode && caseMustBeActive && (isAddressRejected === isCaseParentIdRejectedEnum.UserSentBack) && (
                                            <Button
                                                variant="contained"
                                                color="success"
                                                disabled={declinationDocExist}
                                                onClick={() => handleDeclineAddress(caseInfo.address, "undecline")}
                                            >
                                                ხარვეზის მოხსნა
                                            </Button>

                                        )}
                                    </div>
                                )}
                                {role !== "USER" &&
                                    isObjectInRegistery &&
                                    caseInfo.moveCaseToAgencyRegisterByExpert &&
                                    (
                                        <div
                                            style={{
                                                border: `1px solid #e0e0e0`
                                            }}
                                            className="case-detail"
                                        >
                                            <span className="case-key">შენიშვნა:</span>
                                            {noteEditMode ? (
                                                <TextField
                                                    value={editedNote}
                                                    onChange={(e) => setEditedNote(e.target.value)}
                                                    type="text"
                                                    style={{margin: '0 8px'}}
                                                />
                                            ) : (
                                                <span className="case-value">{caseInfo.note ? caseInfo.note : ""}</span>
                                            )}
                                            <Button
                                                variant="contained"
                                                onClick={() => {
                                                    if (noteEditMode) {
                                                        void handleNoteSave();
                                                    } else {
                                                        setNoteEditMode(true);
                                                    }
                                                }}
                                                style={{marginLeft: '10px'}}
                                            >
                                                {noteEditMode ? 'შენახვა' : (caseInfo.note === null || caseInfo.note === '') ? 'დამატება' : 'რედაქტირება'}
                                            </Button>
                                            {noteEditMode && (
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => {
                                                        setNoteEditMode(false);
                                                        setEditedNote(caseInfo.note || '');
                                                    }}
                                                    style={{marginLeft: '10px'}}
                                                >
                                                    გაუქმება
                                                </Button>
                                            )}

                                        </div>
                                    )}
                            </div>
                        )}
                    </div>
                    {isButtonVisible && isPopup && !hasDeclinedDetails && (
                        <ReuploadDeclinedDocument
                            caseFiles={caseFiles}
                            permitTypeId={permitTypeId}
                            onFileAdded={onFileAdded}
                            onCaseStatusChange={onCaseStatusChange}
                            resetUploadTrigger={() => setStartUpload(false)}
                            startUpload={startUpload}
                            setAllFilesUploaded={setAllFilesUploaded}
                            orderDepartment={orderDepartment}

                        />
                    )}

                    <ConfirmationModal
                        isOpen={confirmationModalOpen}
                        onRequestClose={() => setConfirmationModalOpen(false)}
                        onConfirm={handleSaveConfirmed}
                    />
                    {showAlert && (
                        <CustomAlert
                            message={alertMessage}
                            type={alertType}
                            onClose={() => setShowAlert(false)}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default CaseDetails;
